export default {
  stock: {
    GoodsNo: 'Goods No',
    ProductName: 'Product Name',
    StockBasicUnitQuantity: 'Stock BasicUnit Quantity',
    UnitPrice: 'Unit Price',
    Amount: 'Amount',
    nextQuantity30: 'next Quantity 30',
    nextQuantity60: 'next Quantity 60',
    nextQuantity90: 'next Quantity 90',
    Quantity: 'Quantity',
    stockInNo: 'StockIn No',
    stockOutNo: 'StockOut No',
    documentMaker: 'Document Maker',
    Passed: 'Passed',
    notPass: 'Not Pass',
    ToAudit: 'To Audit',
    stockInStatus: 'StockIn Status',
    stockOutStatus: 'StockOut Status',
    stockInDetail: 'StockIn Detail',
    stockOutDetail: 'StockOut Detail'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/ims/stock.js